(function () {
  'use strict';
  window.initOnDoseFeatures = function () {
    document.querySelectorAll('.odf').forEach(root => {
      if (root.odfCleanup) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let observer;
      function configure() {
        observer?.disconnect();
        root.classList.remove('odf-animate');
        if (motion.matches || !('IntersectionObserver' in window)) return;
        observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('odf-visible');
              observer.unobserve(entry.target);
            }
          });
        }, {threshold: .08});
        root.classList.add('odf-animate');
        root.querySelectorAll('.odf-card:not(.odf-visible)').forEach(card => observer.observe(card));
      }
      configure();
      motion.addEventListener('change', configure);
      root.odfCleanup = function () {
        observer?.disconnect();
        motion.removeEventListener('change', configure);
        root.classList.remove('odf-animate');
        delete root.odfCleanup;
      };
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.initOnDoseFeatures, {once:true});
  else window.initOnDoseFeatures();
})();
